import type React from 'react';

interface HeadingProps {
  title?: string;
  subtitle?: string;
  center?: boolean;
}

const Heading: React.FC<HeadingProps> = ({ title, subtitle, center }) => (
  <div className={center ? 'text-center' : 'text-start'}>
    {title && <div className="text-2xl font-bold">{title}</div>}
    {subtitle && (
      <div className={`${title && 'mt-2'} font-light text-neutral-500`}>
        {subtitle}
      </div>
    )}
  </div>
);

export default Heading;
